import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {RootState} from './store'
import { ITaskType } from '../interface/IOrders_Tasks';


const taskStatusData = sessionStorage.getItem('TaskStatusData') !== null ? 
JSON.parse(sessionStorage.getItem('TaskStatusData') || ''):[ {
  "id": 1,
  "role": "Assembly"
}]  ;
const TaskTypeSlice = createSlice({
  name: 'TaskStatusData',
   initialState: 
    [
      ...taskStatusData 
  //   {
  //     "id": 1,
  //     "role": "Assembly"
  //   },   
   ],
  
  //as ITaskType[],
  reducers: {
    
    // incrementTaskType: (state, action) => {    
    //   state = action.payload;
    //   //return action.payload
    // }
    incrementTaskType: (state, action: PayloadAction<ITaskType[]>) => {   
      state = [] as ITaskType[];
      action.payload.forEach(function(ts) {
       state.push(ts as ITaskType);
   });
    sessionStorage.setItem('TaskStatusData', JSON.stringify(state)); 
      return state;
   }
  },
})



// Action creators are generated for each case reducer function
export const {   incrementTaskType } = TaskTypeSlice.actions
export const TaskStatusData = (state: RootState)=>state
export default TaskTypeSlice.reducer